import {Types} from './PerformanceEvaluationResultsContext';

const ModalReducer = (state:any, action:any) => {
    const {payload,type} = action;
    
    switch(type){
        case Types.GET_INFO_PERFORMANCE_EVAL:
            return {
            ...state,
            _id:payload._id,           
        }
        default:
        return state;
    }
}

export default ModalReducer;